// Module
var code = "<span ng-init=\"tit = row.facebook_interests.join(', ')\" title=\"{{tit}}\">{{tit}}</span>";
// Exports
module.exports = code;